import * as api from '../api'
import { Dispatch } from '@reduxjs/toolkit';
import { setAuth } from '../reducers/authSlice'

export const actionSignin = ({postData, location}: any) => async(dispatch: Dispatch) => {
   
    try{
        //login user
        const { data } = await api.signInAdmin(postData)
        // Save auth data to local storage
        localStorage.setItem("authData", JSON.stringify(data));
        dispatch(setAuth(data));

        // Check if there's a previous location in state or referer
        const previousLocation = location.state?.from || document?.referrer;

        // Check if the previous location is not the login location
        const loginLocation = '/login';

        if (previousLocation && previousLocation !== loginLocation) {
            // Redirect to previous location if it exists and is not the login location
            window.location.replace(previousLocation);
            // navigate(previousLocation, { replace: true });
        } else {
            // Redirect to '/users' if there is no previous location or it is the login location
            // navigate('/users', { replace: true });
            window.location.replace('/');
        }
    }catch(error: any){
        return {
            error,
            success: false,
            status: error.status,
            message: error.response?.data?.message || "Something went wrong",
        };
    }
}